import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { UsersThree, HandCoins, ChatCircleText, ArrowRight, Calculator } from "@phosphor-icons/react";
import UnreadNotifications from "../../components/UnreadNotifications";
import PushSettings from "../../components/PushSettings";

export default function AdvisorOverview() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/stats/advisor").then((r) => setStats(r.data));
  }, []);

  return (
    <div className="space-y-8">
      <header>
        <div className="label-mono mb-2">Panel asesor</div>
        <h1 className="font-display text-4xl md:text-5xl font-black tracking-tighter">Hola, <span className="text-forest">{user?.name?.split(" ")[0]}</span></h1>
      </header>

      <div className="grid md:grid-cols-3 gap-0 border border-hairline bg-surface">
        <Card icon={UsersThree} label="Clientes asignados" value={stats?.assigned_clients ?? "—"} to="/app/clientes" />
        <Card icon={HandCoins} label="Créditos pendientes" value={stats?.pending_loans ?? "—"} to="/app/solicitudes" border />
        <Card icon={ChatCircleText} label="Mensajes sin leer" value={stats?.unread_messages ?? "—"} to="/app/chat" />
      </div>

      <div className="bento p-8">
        <h2 className="font-display text-2xl font-bold mb-2">Acciones rápidas</h2>
        <p className="text-inkMuted text-sm mb-6">Accede a tus herramientas de atención de cartera.</p>
        <div className="flex flex-wrap gap-3">
          <Link to="/app/clientes" className="h-11 px-5 bg-forest text-bg text-sm font-semibold flex items-center gap-2">Ver clientes <ArrowRight size={14} weight="bold" /></Link>
          <Link to="/app/solicitudes" className="h-11 px-5 border border-hairline text-sm font-semibold flex items-center gap-2">Revisar solicitudes</Link>
          <Link to="/app/simulador" className="h-11 px-5 border border-hairline text-sm font-semibold flex items-center gap-2"><Calculator size={14} weight="bold" /> Simulador</Link>
          <Link to="/app/chat" className="h-11 px-5 border border-hairline text-sm font-semibold flex items-center gap-2">Ir al chat</Link>
        </div>
      </div>

      <UnreadNotifications />

      <PushSettings />
    </div>
  );
}

function Card({ icon: Icon, label, value, to, border }) {
  return (
    <Link to={to} className={`block p-8 group hover:bg-bg ${border ? "border-x border-hairline" : ""}`}>
      <Icon size={28} weight="duotone" className="text-forest mb-6" />
      <div className="label-mono">{label}</div>
      <div className="font-display text-5xl font-black mt-1">{value}</div>
      <div className="text-sm text-forest mt-4 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">Abrir <ArrowRight size={14} weight="bold" /></div>
    </Link>
  );
}
